export { default, getServerSideProps } from '../src/pages/_error';
